module.exports = __webpack_public_path__ + "assets/pizza_disabled-ea90bb.svg";